import { Logo } from "src/assets";
import { useContext } from "react";
import { Box, Stack } from "@mui/material";
import BackButton from "../Shared/BackButton";
import { EV_PATHS } from "src/consts/Routes/Ev";
import { ThemeValues } from "../ThemeUsage/theme";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const BrandItemThemeChanger = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);

  const [searchParams] = useSearchParams();
  const navigateFrom = searchParams.get("navigate-from");
  const showBackButton = navigateFrom === "overview";

  const showBackBtn =
    pathname === SMART_CHARGING_ROUTES.COMPATIBILITY ||
    pathname === SMART_CHARGING_ROUTES.MODEL ||
    pathname === SMART_CHARGING_ROUTES.TERMS ||
    pathname === SMART_CHARGING_ROUTES.MANUFACTURER_SEARCH ||
    pathname === SMART_CHARGING_ROUTES.MODEL_SEARCH ||
    pathname === SMART_CHARGING_ROUTES.STATUS ||
    pathname === SMART_CHARGING_ROUTES.INTRO ||
    pathname === SMART_CHARGING_ROUTES.CONNECT_CONFIRM ||
    pathname === SMART_CHARGING_ROUTES.CONNECTING ||
    pathname === SMART_CHARGING_ROUTES.CONNECTING_ERROR ||
    pathname === SMART_CHARGING_ROUTES.OVERVIEW_DETAILS ||
    pathname === EV_PATHS.COMPATIBILITY ||
    pathname === EV_PATHS.TERMS ||
    showBackButton
      ? true
      : false;

  const getLogo = () => {
    switch (themeName) {
      case ThemeValues.SMA:
        return <></>;
      case ThemeValues.lichtblick:
        return <></>;
      case ThemeValues.default:
        return <Logo color={"white"} />;
      default:
        return <Logo color={"white"} />;
    }
  };

  return (
    <Stack direction={"row"} alignItems={"center"}>
      <Box flex={1}>
        {showBackBtn && (
          <BackButton
            variant={
              themeName === ThemeValues.lichtblick ||
              themeName === ThemeValues.SMA
                ? "dark"
                : "light"
            }
            onClick={() => navigate(-1)}
            sx={(theme) => ({
              backgroundColor: theme.palette.background.default,
              "&:hover": {
                backgroundColor: theme.palette.background.default,
              },
              display: { xs: "flex", sm: "none" },
            })}
          />
        )}
      </Box>
      <Box>{getLogo()}</Box>
      <Box flex={1}></Box>
    </Stack>
  );
};
export default BrandItemThemeChanger;
